const Error404 = () => (
    <main className="conatiner">
        <h1>404: page not found</h1>
    </main>
)

export default Error404;